<template>
    <div>
        <!-- <pre>{{ selectedFiltered_client_details }}</pre> -->
        <!-- start -->

        <DashboardLayout>
            <template #summary>
                <SummaryStatCard
                    v-for="card in summaryCards"
                    :key="card.label"
                    :label="card.label"
                    :value="card.value"
                    :tone="card.tone"
                />
            </template>
            <template #default>
                <div v-if="core.marketing_banner_src.length > 0" class="cd-banner">
                    <b-img :src="core.marketing_banner_src" fluid alt="Marketing banner"></b-img>
                </div>

                <div v-if="loggedIn_user_role == 1" class="cd-backbar">
                    <b-button variant="outline-secondary" size="sm" @click="resetClientData">
                        <i class="mdi mdi-arrow-left mr-1"></i> Go back
                    </b-button>
                </div>

                <!-- Client details -->
                <section v-if="ready && selected_client_details" class="cd-card">
                    <header class="cd-card__head">
                        <div>
                            <h2 class="cd-title">{{ selectedFiltered_client_details.company_name }}</h2>
                            <span v-if="selectedFiltered_client_details.type" class="cd-type-pill">
                                {{ selectedFiltered_client_details.type }}
                            </span>
                        </div>
                        <b-button v-if="loggedIn_user_role == 1" variant="primary" size="sm" @click="showEditClientModal">
                            <i class="mdi mdi-pencil-box-outline mr-1"></i> Edit Details
                        </b-button>
                    </header>

                    <div class="cd-section">
                        <h3 class="cd-section__label">Company</h3>
                        <dl class="cd-grid">
                            <div class="cd-field">
                                <dt>Customer no</dt>
                                <dd>{{ selectedFiltered_client_details.customer_no || "—" }}</dd>
                            </div>
                            <div class="cd-field">
                                <dt>Reg no</dt>
                                <dd>{{ selectedFiltered_client_details.company_reg || "—" }}</dd>
                            </div>
                            <div class="cd-field">
                                <dt>VAT no</dt>
                                <dd>{{ selectedFiltered_client_details.vat_no || "—" }}</dd>
                            </div>
                        </dl>
                    </div>

                    <div class="cd-section">
                        <h3 class="cd-section__label">Contact</h3>
                        <dl class="cd-grid">
                            <div class="cd-field">
                                <dt>Contact person</dt>
                                <dd>{{ selectedFiltered_client_details.contact_person || "—" }}</dd>
                            </div>
                            <div class="cd-field">
                                <dt>Contact no</dt>
                                <dd>{{ selectedFiltered_client_details.contact_no || "—" }}</dd>
                            </div>
                            <div class="cd-field">
                                <dt>Email</dt>
                                <dd>{{ selectedFiltered_client_details.emails || "—" }}</dd>
                            </div>
                        </dl>
                    </div>

                    <div class="cd-section">
                        <h3 class="cd-section__label">Address</h3>
                        <dl class="cd-grid">
                            <div class="cd-field">
                                <dt>City</dt>
                                <dd>{{ selectedFiltered_client_details.city || "—" }}</dd>
                            </div>
                            <div class="cd-field">
                                <dt>Province</dt>
                                <dd>{{ selectedFiltered_client_details.province || "—" }}</dd>
                            </div>
                            <div class="cd-field">
                                <dt>Postal code</dt>
                                <dd>{{ selectedFiltered_client_details.postal_code || "—" }}</dd>
                            </div>
                            <div class="cd-field cd-field--wide">
                                <dt>Street address</dt>
                                <dd>{{ selectedFiltered_client_details.address || "—" }}</dd>
                            </div>
                        </dl>
                    </div>
                </section>

                <!-- Orders / Users tabs -->
                <section class="cd-card cd-card--flush">
                    <div class="cd-tabbar">
                        <b-button v-if="!viewable" variant="success" size="sm" @click="addOrder">
                            <i class="mdi mdi-plus mr-1"></i> Create new order
                        </b-button>
                        <b-button v-if="viewable" variant="success" size="sm" @click="showAddUserClientModal">
                            <i class="mdi mdi-plus mr-1"></i> Add a user
                        </b-button>
                    </div>
                    <b-tabs class="cd-tabs">
                        <b-tab @click="checkTab('orders')" title="Orders" active>
                            <simpleLayout :items_count="10">
                                <template #content>
                                    <clientOrderTable :repUser="repUser" />
                                </template>
                            </simpleLayout>
                        </b-tab>
                        <b-tab @click="checkTab('users')" title="Users" v-if="loggedIn_user_role == 1">
                            <simpleLayout :items_count="10">
                                <template #content>
                                    <clientUsersTable />
                                </template>
                            </simpleLayout>
                        </b-tab>
                    </b-tabs>
                </section>
            </template>
        </DashboardLayout>

        <clientUsersAddModal v-if="show_modal" />
        <clientEditModal v-if="show_modal_editClient" />
        <!-- <clientCreateOrderModal v-if="show_modal_addOrder" :repUser="repUser" /> -->
    </div>
</template>

<script>
import simpleLayout from "@/components/layout-templates/simple-layout.vue";
import clientOrderTable from "./clientOrderTable.vue";
import clientUsersTable from "./clientUsersTable.vue";
import clientUsersAddModal from "./clientUsersAddModal.vue";
import clientEditModal from "./clientEditModal.vue";
import DashboardLayout from "@/components/shared/DashboardLayout.vue";
import SummaryStatCard from "@/components/shared/SummaryStatCard.vue";
import { adminComputed, clientMethods, clientComputed, repMethods, repComputed } from "@/state/helpers";
//eslint-disable-next-line
import axios from "axios";
// import clientCreateOrderModal from "./clientCreateOrderModal.vue";

export default {
    components: {
        //eslint-disable-next-line
        simpleLayout,
        //eslint-disable-next-line
        clientOrderTable,
        //eslint-disable-next-line
        clientUsersTable,
        clientUsersAddModal,
        clientEditModal,
        DashboardLayout,
        SummaryStatCard,
        // clientCreateOrderModal,
    },
    data: () => ({
        clientId: -1,
        show_modal: false,
        show_modal_editClient: false,
        show_modal_addOrder: false,
        ready: true,
        busySaving: false,
        viewable: false,
    }),
    props: {
        repUser: Boolean,
    },
    computed: {
        ...adminComputed,
        ...clientComputed,
        ...repComputed,
        getUserRole() {
            return this.loggedIn_user_role;
        },
        // This-client order summary above the orders list, derived client-side from
        // selected_client_orders by status_id (1 Received, 2 Confirmed, 3 Processing,
        // 4 Awaiting Collection, 5 Dispatched). Returns [] until the client object is
        // loaded — selected_client_details defaults to [] (array) and becomes an object
        // once api/clients/client resolves, so the array check is the first-paint guard.
        // Overdue = due_date in the past AND not dispatched (status_id !== 5); warning tone.
        summaryCards() {
            if (!this.selected_client_details || Array.isArray(this.selected_client_details)) {
                return [];
            }
            const orders = this.selected_client_orders || [];
            const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
            let overdue = 0;
            const now = Date.now();

            for (let i = 0; i < orders.length; i++) {
                const order = orders[i];
                const statusId = Number(order.status_id);
                if (counts[statusId] !== undefined) {
                    counts[statusId]++;
                }
                // Not dispatched = any status before Dispatched (5). due_date and status_id
                // are both confirmed columns on the client-order payload.
                if (order.due_date && statusId !== 5) {
                    // MySQL datetimes are space-separated ("YYYY-MM-DD HH:MM:SS") and parse to
                    // Invalid Date on Safari/iOS — swap the space for "T" first (1.4 review fix).
                    const due = new Date(String(order.due_date).replace(" ", "T")).getTime();
                    if (!isNaN(due) && due < now) {
                        overdue++;
                    }
                }
            }

            return [
                { label: "Total orders", value: orders.length, tone: "neutral" },
                { label: "In Production", value: counts[2] + counts[3], tone: "neutral" },
                { label: "Awaiting Collection", value: counts[4], tone: "neutral" },
                { label: "Overdue", value: overdue, tone: overdue > 0 ? "warning" : "neutral" },
            ];
        },
        client_type_select_options() {
            return [
                {
                    value: null,
                    text: "Please select an option",
                    disabled: true,
                },
                { value: "stockist", text: "Stockist" },
                { value: "reseller", text: "Reseller" },
                { value: "individual", text: "Individual" },
            ];
        },
    },
    methods: {
        ...clientMethods,
        ...repMethods,
        resetClientData() {
            this.setSelectedClientId(-1);
            // this.$router.push({ path: "/clients" });
            //go back to prev route
            this.$router.back();
        },
        checkTab(data) {
            if (this.client_users.length > 0) {
                this.$nextTick(() => {
                    window.webix.$$("clientUsersTable").refresh();
                });
            }

            //shows the + Add a user button
            data == "orders" ? (this.viewable = false) : (this.viewable = true);
        },
        showAddUserClientModal() {
            this.show_modal = true;
            this.$nextTick(() => {
                this.$bvModal.show("clientUsersAddModal");
                this.$root.$once("bv::modal::hidden", (event) => {
                    if (event.type == "hidden" && event.componentId == "clientUsersAddModal") {
                        this.show_modal = false;
                        this.edit_id = -1;
                    }
                });
            });
        },
        showEditClientModal() {
            this.show_modal_editClient = true;
            this.$nextTick(() => {
                this.$bvModal.show("clientEditModal");
                this.$root.$once("bv::modal::hidden", (event) => {
                    if (event.type == "hidden" && event.componentId == "clientEditModal") {
                        this.show_modal_editClient = false;
                        this.edit_id = -1;
                    }
                });
            });
        },
        addOrder() {
            this.show_modal_addOrder = true;
            let params;
            if (this.repUser) {
                params = {
                    client_id: this.$route.params.clientid,
                    rep_id: this.selected_rep_id,
                };
            } else {
                params = {
                    client_id: this.$route.params.clientid,
                };
            }
            this.setSelectedClientDetails(params);

            this.$router.push({ path: `/create-order/${this.$route.params.clientid}` });

            // this.show_modal_addOrder = false;
            // this.$nextTick(() => {
            //     this.$bvModal.show("clientCreateOrderModal");
            //     this.$root.$once("bv::modal::hidden", (event) => {
            //         if (event.type == "hidden" && event.componentId == "clientCreateOrderModal") {
            //             //will refresh the table on screen
            //             let params;
            //             if (this.repUser) {
            //                 params = {
            //                     client_id: this.$route.params.clientid,
            //                     rep_id: this.selected_rep_id,
            //                 };
            //             } else {
            //                 params = {
            //                     client_id: this.$route.params.clientid,
            //                 };
            //             }
            //             this.setSelectedClientDetails(params);
            //             this.show_modal_addOrder = false;
            //         }
            //     });
            // });
        },
        loadClientDetails() {
            let params;
            if (this.repUser) {
                params = {
                    client_id: this.$route.params.clientid,
                    rep_id: this.selected_rep_id,
                };
            } else {
                params = {
                    client_id: this.$route.params.clientid,
                };
            }
            this.setSelectedClientId(this.$route.params.clientid).then(() => {
                this.setSelectedClientDetails(params).then(() => {
                    this.ready = true;
                    this.setFilteredSelectedClientDetails();
                });
            });
        },
    },
    mounted() {
        // alert(`aler ${this.$route.params.clientid}`);

        if (this.clients.length == 0) {
            this.getClients().then(() => {
                //method unique to this component
                this.loadClientDetails();
                // this.ready = true;
            });
        } else {
            this.loadClientDetails();
        }

        if (this.repUser && this.selected_rep_id == -1) {
            this.$router.push("/");
        }

        this.clientId = this.$route.params.clientid;
    },
};
</script>

<style lang="scss" scoped>
.cd-banner {
    margin-bottom: var(--space-6);
    display: flex;
    justify-content: center;
}

.cd-backbar {
    margin-bottom: var(--space-4);
}

.cd-card {
    background: var(--c-surface);
    border: 1px solid var(--c-border);
    border-radius: var(--radius-card);
    box-shadow: var(--shadow-card);
    padding: var(--space-6);
    margin-bottom: var(--space-6);

    &--flush {
        padding: var(--space-4) var(--space-6) var(--space-6);
    }
}

.cd-card__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: var(--space-4);
    margin-bottom: var(--space-6);
}

.cd-title {
    font-size: var(--t-h2);
    font-weight: 600;
    color: var(--c-text);
    margin: 0 0 var(--space-2);
}

.cd-type-pill {
    display: inline-block;
    font-size: var(--t-caption);
    font-weight: 600;
    text-transform: capitalize;
    color: var(--c-primary);
    background: rgba(59, 91, 219, 0.1);
    border: 1px solid var(--c-primary);
    border-radius: 50rem;
    padding: 2px var(--space-3);
}

.cd-section {
    & + & {
        margin-top: var(--space-6);
        padding-top: var(--space-6);
        border-top: 1px solid var(--c-border);
    }
}

.cd-section__label {
    font-size: var(--t-caption);
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--c-text-muted);
    margin: 0 0 var(--space-4);
}

.cd-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: var(--space-4) var(--space-6);
    margin: 0;
}

.cd-field {
    min-width: 0;

    dt {
        font-size: var(--t-caption);
        font-weight: 600;
        color: var(--c-text-muted);
        margin-bottom: 2px;
    }

    dd {
        font-size: var(--t-body);
        color: var(--c-text);
        margin: 0;
        word-break: break-word;
    }

    &--wide {
        grid-column: 1 / -1;
    }
}

.cd-tabbar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: var(--space-2);
}

@media (max-width: 768px) {
    .cd-grid {
        grid-template-columns: 1fr;
    }

    .cd-card__head {
        flex-direction: column;
    }
}
</style>
